import React from "react";
import "./embeddedVideo.css";

class EmbeddedVideo extends React.Component {
  render() {
    if (this.props.host === "YouTube") {
      return (
        <div className="contentBlock embeddedVideo YouTube">
          <iframe
            src={`https://www.youtube.com/embed/${this.props.videoId}`}
            frameBorder="0"
            allowFullScreen
          />
        </div>
      );
    }
    return (
      <div className="contentBlock embeddedVideo vimeo">
        <iframe
          src={`https://player.vimeo.com/video/${this.props.videoId}`}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    );
  }
}
export default EmbeddedVideo;
